export const IATA_NAMES = {
	FO: 'Flybondi',
	AR: 'Aerolíneas Argentinas',
	WJ: 'JetSmart',
	G3: 'GOL',
	JJ: 'TAM',
	O4: 'Andes L.A.',
	'5U': 'LADE',
	ZP: 'Paranair',
	H2: 'SKY'
};
